<template>
  <transition
    name="custom-classes-transition"
    class="animate__faster"
    enter-active-class="animate__animated animate__flash animate__fadeIn"
    leave-active-class="animate__animated animate__flash animate__fadeOut"
  >
    <div class="loading-wrapper" v-if="localShow" :class="isTpass ? 'tpass-loading' : ''">
      <div class="loading-container">
        <div class="loading-content">
          <div class="d-flex justify-content-center mb-3">
            <!-- <template v-if="localShow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="37 -5 120 120"
                class="loading-svg"
              >
                <path
                  class="meter-2"
                  d="M55,90
               A55,55 0 1,1 140,90"
                  style="fill: none"
                />
              </svg>
            </template>
            <template v-else> -->
              <b-spinner :variant="isTpass ? 'primary-2' : 'light'" label="Loading..."></b-spinner>
            <!-- </template> -->
          </div>
          <div v-if="isTpass" class="loading-text pt-3">載入中</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isTpass: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localShow: this.show,
    };
  },

  watch: {
    show() {
      this.localShow = this.show;
    },
  },
};
</script>
